import React, { useEffect } from "react";
import { useSnackbar } from "notistack";
import { CircularProgress, Backdrop } from "@mui/material";
import { getFormInvalid } from "../helpers/getFormInvalid";
import { checkInvalidField } from "../helpers/checkInvalidField";
import EditDialog from "../Dialogs/EditDialog";
import setupEdit from "../helpers/setupEdit";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "./../firebase";

export default function AccountEdit(props) {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(true);
  const [isReady, setIsReady] = React.useState(false);
  const [editDialogOpen, setEditDialogOpen] = React.useState(false);
  const [importTitle, setImportTitle] = React.useState(
    "Edit Account Information",
  );
  const [editFeature, setEditFeature] = React.useState(null);
  const [editFiles, setEditFiles] = React.useState([]);
  const [editSchema, setEditSchema] = React.useState([]);
  const [formErrorMessage, setformErrorMessage] = React.useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        onEdit(props.user);
        // setProject(props.project);
      } catch (error) {
        console.error("Error getting document:", error);
        enqueueSnackbar(error.message, {
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
          variant: "error",
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (isLoading === true && isReady === false) {
      setIsReady(true);
      fetchData();
    }
  }); 

  // const onAddNew = (project_id) => {
  //   var item = {};
  //   var schema = getSchema("observation");
  //   schema.forEach((fd) => {
  //     item[fd.name] = "";
  //   });

  //   item["id"] = "new";
  //   item["project_id"] = project_id;
  //   item = applyEditTrackingFields(item, props.user);

  //   setIsLoading(false);
  //   setEditSchema(schema);
  //   setEditFeature(item);
  //   setEditFiles([]);
  //   setImportTitle("New Observation");
  //   setEditDialogOpen(true);
  //   setIsLoading(false);
  // };

  const onEdit = (item) => {
    const results = setupEdit({ ...item }, "account");

    setIsLoading(false);
    setEditSchema([
      {
        name: "displayName",
        default: "",
        type: "string",
        maxLength: 25,
        selectables: [],
        similair: [],
        helperText: "",
        nullable: true,
        readOnly: false,
        error: false,
      },
      {
        name: "bio",
        default: "",
        type: "string",
        maxLength: 255,
        selectables: [],
        similair: [],
        helperText: "",
        nullable: true,
        readOnly: false,
        error: false,
      },
    ]);
    setEditFeature({ ...results.item });
    setEditFiles([]);
    setImportTitle(`Edit Account Information`);
    setEditDialogOpen(true);
  };

  const onEditSave = async () => {
    try {
      //check for invalid
      var feat = { ...editFeature };
      var invalidResults = getFormInvalid(feat, editSchema);
      if (invalidResults.isInvalid === true) {
        setEditFeature({ ...invalidResults.feature });
        setEditSchema([...invalidResults.schema]);
        setformErrorMessage(invalidResults.formErrorMessage);
        return;
      }

      setIsLoading(true);

      // Reference to the specific document
      const docRef = doc(db, "users", props.user.uid);
      // Update only two properties
      await updateDoc(docRef, {
        displayName: editFeature.displayName,
        bio: editFeature.bio,
      });

      var userr = { ...props.user };
      userr.displayName = editFeature.displayName;
      userr.bio = editFeature.bio;

      props.passUpProject(userr);

      enqueueSnackbar("Account updated successfully", {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "success",
      });
      setIsLoading(false);
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  const onEditChange = (e) => {
    try {
      var att = editSchema.find((item) => item.name === e.target.name);
      const formErrorMessage = checkInvalidField(e.target.value, att);
      if (att.type === "date" && e.target.value.length > 0) {
        var date = new Date(e.target.value);
        editFeature[e.target.name] = date.toISOString().split("T")[0];
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      } else if (att.type === "bit") {
        editFeature[e.target.name] = e.target.checked;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      } else {
        editFeature[e.target.name] = e.target.value;
        setEditFeature({ ...editFeature });
        setformErrorMessage(formErrorMessage);
      }
    } catch (error) {
      console.error("Error:", error);
      enqueueSnackbar(error.message, {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
        variant: "error",
      });
    }
  };

  const onEditCancel = () => {
    setformErrorMessage("");
    setEditDialogOpen(false);
    props.onEditClick();
  };

  return isLoading ? (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={isLoading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  ) : (
    <EditDialog
      feature={editFeature}
      editFiles={editFiles}
      importTitle={importTitle}
      // getAcceptedFiles={getAcceptedFiles}
      // onEditFileCommentChange={onEditFileCommentChange}
      // onRemoveEditFile={onRemoveEditFile}
      schema={editSchema}
      onChange={onEditChange}
      onEditSave={onEditSave}
      onEditDelete={null}
      isOpen={editDialogOpen}
      onClose={onEditCancel}
      formErrorMessage={formErrorMessage}
      allowDelete={false}
      allowFiles={false}
    />
  );
}
